import { IColumnHookInput, IColumnHookOutput } from 'dromo-uploader-react'

export function convertZeroToNull(
  values: IColumnHookInput[]
): IColumnHookOutput[] {
  return values.map((row) => {
    // Return the row unchanged if its value is not zero.
    if (row.value !== 0) {
      return row
    }

    const rowOutput: IColumnHookOutput = {
      index: row.index,
      value: null,
      info: [
        {
          message: 'Converted 0 to null',
          level: 'info',
        },
      ],
    }
    return rowOutput
  })
}
